import React from 'react';
import { TimeNYzerWortmarke } from './TimeNYzerWortmarke';
import { Fusszeile } from './Fusszeile';

export const TIMENYZER_VERLAUF = 'linear-gradient(135deg,#3566e0 0%,#1e40af 48%,#16296e 100%)';
const FOTO_VERLAEUFE = 'linear-gradient(180deg, rgba(10,24,78,.80) 0%, rgba(16,36,110,.62) 34%, rgba(20,48,140,.22) 58%, rgba(10,24,78,.55) 100%), '
  + 'linear-gradient(135deg, rgba(53,102,224,.25) 0%, rgba(30,64,175,.20) 50%, rgba(22,41,110,.30) 100%)';
const SCHATTEN = '0 1px 2px rgba(3,10,40,.35)';

// Ab 1024 px: Schulfoto mit Text; Inhalt oben im dunklen Himmel, nicht auf der hellen Glasfassade.
const FotoFlaeche = () => (
  <aside className="relative overflow-hidden max-lg:hidden" data-testid="anmelde-flaeche">
    <div className="absolute inset-0" style={{ backgroundImage: 'url(/anmeldung/schule.jpg)', backgroundSize: 'cover', backgroundPosition: '50% 100%', filter: 'saturate(.82)' }} />
    <div className="absolute inset-0" style={{ background: FOTO_VERLAEUFE }} />
    <div className="relative flex flex-col items-center text-center text-white" style={{ padding: 'clamp(56px, 12vh, 120px) 44px 0', gap: 26 }}>
      <TimeNYzerWortmarke groesse="gross" testid="anmelde-wortmarke-gross" />
      <div className="flex flex-col items-center gap-3">
        <h2 className="max-w-[420px] text-[30px] font-bold leading-[1.2] tracking-[-0.018em]" style={{ fontFamily: "'Inter', sans-serif", textShadow: SCHATTEN }} data-testid="anmelde-flaeche-titel">
          Stundenerfassung für Schulbegleiter
        </h2>
        <p className="max-w-[420px] text-base leading-[1.55] text-white/[.92]" style={{ textShadow: SCHATTEN }}>
          Erfassen Sie Ihre Arbeitszeiten einfach und intuitiv. Digital unterschreiben und direkt einreichen.
        </p>
      </div>
    </div>
  </aside>
);

// Unter 1024 px: Leiste mit Wortmarke und Boot-Wasserzeichen, ohne Foto.
const Leiste = () => (
  <div className="relative flex h-[112px] items-center overflow-hidden px-5 lg:hidden" style={{ background: TIMENYZER_VERLAUF }} data-testid="anmelde-leiste">
    <TimeNYzerWortmarke groesse="klein" testid="anmelde-wortmarke-klein" />
    <img src="/anmeldung/boot.png" alt="" aria-hidden="true" className="pointer-events-none absolute"
      style={{ width: 170, height: 170, right: -40, top: -32, opacity: 0.09, filter: 'brightness(0) invert(1)' }} />
  </div>
);

// Rahmen für Anmeldung, Passwort vergessen/festlegen und Zugangscode (Vorbild PersoNYzer AnmeldeRahmen.js).
export const AnmeldeRahmen = ({ children, breit = false }) => (
  <div className="min-h-screen lg:grid lg:grid-cols-[45%_55%]" data-testid="anmelde-rahmen">
    <FotoFlaeche />
    <Leiste />
    <div className="flex min-h-[calc(100vh-112px)] flex-col bg-[#f8fafc] lg:min-h-screen">
      <div className="flex flex-1 flex-col px-5 pt-5 sm:px-6">
        <div className="h-[34px] max-lg:hidden" />
        <main className="mx-auto flex w-full flex-1 flex-col lg:justify-center" style={{ maxWidth: breit ? 480 : 360 }} data-testid="anmelde-main">
          <div>{children}</div>
        </main>
      </div>
      <Fusszeile />
    </div>
  </div>
);

export default AnmeldeRahmen;
